import React, { useState } from 'react';
import { Camera, Play, Heart, Users, Calendar, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { playSoundIfEnabled } from '../utils/sounds';

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/j6yd25ig_4C7B1785-D809-4E99-96FA-A441DD7F59CC.JPG',
      title: 'Summer Workshop - Midsummer Night\'s Dream',
      category: 'summer',
      description: 'Our magical outdoor performance under the flower arch'
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/0di3eedu_2A0A1B6C-CAB3-436F-84AE-3617611975FE.jpeg',
      title: 'Drama Games Workshop',
      category: 'activities',
      description: 'Building confidence through creative expression'
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/lr9d39cm_420D9E0D-2267-44E2-90DD-199105493BCE.jpeg',
      title: 'Creative Drama Workshop',
      category: 'activities',
      description: 'Learning through play and imagination'
    },
    {
      id: 4,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/yzvrp2k0_IMG_8101.jpeg',
      title: 'Halloween Workshop - Spooky Masks',
      category: 'halloween',
      description: 'Creating atmospheric characters for our Halloween production'
    },
    {
      id: 5,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/9gr297lc_IMG_3346.jpeg',
      title: 'Halloween Film Project',
      category: 'halloween',
      description: 'Dramatic lighting for our annual Halloween film'
    },
    {
      id: 6,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/iz2ysumk_IMG_3347.jpeg',
      title: 'Halloween Film - Behind the Scenes',
      category: 'halloween',
      description: 'Professional cinematography techniques in action'
    },
    {
      id: 7,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/mx1lfa7c_IMG_3349.jpeg',
      title: 'Halloween Character Design',
      category: 'halloween',
      description: 'Creating memorable characters for film projects'
    },
    {
      id: 8,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/bkt1t9g2_IMG_8826.jpeg',
      title: 'Christmas Charity Drive',
      category: 'christmas',
      description: 'Collecting chocolates for The Gate House homeless shelter'
    },
    {
      id: 9,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/0di3eedu_2A0A1B6C-CAB3-436F-84AE-3617611975FE.jpeg',
      title: 'Drama Games Workshop',
      category: 'activities',
      description: 'Fun drama exercises building teamwork and creativity'
    },
    {
      id: 10,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/1r99u2ck_ABB5B30A-6ADE-4694-ADB2-CC1789E6307C.jpeg',
      title: 'Mask Making Workshop',
      category: 'activities',
      description: 'Creative arts and character development'
    },
    {
      id: 11,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/f6zbs83r_3364A91D-C544-4EE4-8A48-CD3DB33A7825.jpeg',
      title: 'Creative Workshop - Mask Design',
      category: 'activities',
      description: 'Collaborative creativity in action'
    },
    {
      id: 12,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/0fk6bc6s_17B238FF-A26D-4C3D-A681-EF9555352790.jpeg',
      title: 'Art & Drama Integration',
      category: 'activities',
      description: 'Combining visual arts with theatrical expression'
    },
    {
      id: 13,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/t60hitzm_8CD1BAE2-5E72-4A44-934A-E1AB772AAB1E.jpeg',
      title: 'Community Charity Project',
      category: 'community',
      description: 'Food bank donation drive - giving back to our community'
    },
    {
      id: 14,
      url: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/tinsj9lg_B11291F8-B76D-44CD-9ED7-B0DFF3E89062.jpeg',
      title: 'Our Amazing Team',
      category: 'team',
      description: 'The passionate instructors behind INSPIRE STUDIO OXFORD'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Photos', icon: <Camera className="w-4 h-4" /> },
    { id: 'summer', label: 'Summer', icon: <Calendar className="w-4 h-4" /> },
    { id: 'halloween', label: 'Halloween', icon: <Play className="w-4 h-4" /> },
    { id: 'christmas', label: 'Christmas', icon: <Heart className="w-4 h-4" /> },
    { id: 'activities', label: 'Activities', icon: <Users className="w-4 h-4" /> },
    { id: 'community', label: 'Community', icon: <Heart className="w-4 h-4" /> }
  ];

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Back Button */}
        <Link
          to="/"
          className="flex items-center gap-2 text-light-pink hover:text-white transition-colors mb-8 group"
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          Back to Home
        </Link>

        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-light-pink/10 rounded-full px-4 py-2 mb-4">
            <Camera className="w-4 h-4 text-light-pink" />
            <span className="text-light-pink text-sm font-mono uppercase tracking-wider">
              Our Gallery
            </span>
          </div>
          <h1 className="text-5xl lg:text-6xl font-display font-bold text-white mb-6">
            Workshop Moments
          </h1>
          <p className="text-xl text-mid-grey max-w-3xl mx-auto">
            Explore the creativity, joy, and magic of our drama workshops through these memorable moments
          </p>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => {
                playSoundIfEnabled('click');
                setFilter(cat.id);
              }}
              className={`flex items-center gap-2 px-6 py-3 rounded-full font-mono text-sm uppercase tracking-wider transition-all duration-300 ${
                filter === cat.id
                  ? 'bg-light-pink text-black scale-105'
                  : 'bg-white/5 text-mid-grey hover:bg-white/10 hover:text-white'
              }`}
            >
              {cat.icon}
              {cat.label}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-2xl cursor-pointer transform transition-all duration-500 hover:-translate-y-2 hover:scale-105"
              onClick={() => {
                playSoundIfEnabled('magic');
                setSelectedImage(image);
              }}
              style={{
                animationDelay: `${index * 100}ms`,
                opacity: 0,
                animation: 'fadeInUp 0.6s ease-out forwards'
              }}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white font-semibold text-lg mb-2">{image.title}</h3>
                  <p className="text-light-pink text-sm">{image.description}</p>
                </div>
              </div>
              <div className="absolute top-4 right-4 bg-light-pink text-black px-3 py-1 rounded-full text-xs font-mono uppercase tracking-wider">
                {image.category}
              </div>
            </div>
          ))}
        </div>

        {filteredImages.length === 0 && (
          <div className="text-center py-16">
            <Camera className="w-16 h-16 text-mid-grey mx-auto mb-4" />
            <p className="text-mid-grey text-lg">No photos in this category yet</p>
          </div>
        )}

        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={() => {
              playSoundIfEnabled('click');
              setSelectedImage(null);
            }}
          >
            <button
              className="absolute top-4 right-4 text-white text-4xl hover:text-light-pink transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <div className="max-w-6xl max-h-[90vh] relative" onClick={(e) => e.stopPropagation()}>
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-[80vh] object-contain rounded-2xl"
              />
              <div className="mt-6 text-center">
                <h3 className="text-2xl font-bold text-white mb-2">{selectedImage.title}</h3>
                <p className="text-light-pink">{selectedImage.description}</p>
              </div>
            </div>
          </div>
        )}

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-light-pink/20 via-mid-purple/20 to-light-yellow/20 rounded-3xl p-12 text-center border border-light-pink/20">
          <h2 className="text-3xl font-display font-bold text-white mb-4">
            Want to Be Part of Our Next Workshop?
          </h2>
          <p className="text-mid-grey mb-6 max-w-2xl mx-auto">
            Join us for unforgettable drama experiences where your child can shine, create, and grow!
          </p>
          <Link
            to="/workshops"
            className="cta-button large bg-light-pink text-black hover:bg-mid-yellow transition-all duration-300 inline-flex items-center gap-2"
            onClick={() => playSoundIfEnabled('success')}
          >
            View Workshops
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Gallery;
